module.exports = __webpack_public_path__ + "static/media/cafe24-standoil2.f59fb057.png";